"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __importStar(require("angular"));
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
var PageHeaderFooterModalController = /** @class */ (function () {
    function PageHeaderFooterModalController($scope, 
    // @ts-ignore
    headerFooterService, 
    // @ts-ignore
    pageHeaderFooterGenerator, 
    // @ts-ignore
    pageHeaderFooterOptionsService) {
        var _this = this;
        this.$scope = $scope;
        this.headerFooterService = headerFooterService;
        this.pageHeaderFooterGenerator = pageHeaderFooterGenerator;
        this.pageHeaderFooterOptionsService = pageHeaderFooterOptionsService;
        this.CONTENT_FORMAT_OPTIONS = ['FONT', 'SIZE', 'COLOR'];
        this.$ctrl = this;
        $scope.$ctrl = this.$ctrl;
        angular_1.extend(this.$ctrl, {
            $onInit: function () {
                _this.$ctrl.type = $scope.type;
                _this.$ctrl.headerFooterLayout = headerFooterService.getProperties();
                // @ts-ignore
                _this.$ctrl.typeModel = _this.$ctrl.headerFooterLayout[_this.$ctrl.type];
                var headerFooterType = $scope.type;
                // @ts-ignore
                var options = _this.$ctrl.headerFooterLayout[headerFooterType];
                _this.$ctrl.quillDelta = options.quillObject;
                pageHeaderFooterOptionsService.setContents(_this.$ctrl.type, _this.$ctrl.quillDelta);
            },
            save: this.saveHeaderFooter,
            isSaveButtonDisabled: this.isSaveButtonDisabled
        });
    }
    PageHeaderFooterModalController.prototype.isSaveButtonDisabled = function () {
        return this.pageHeaderFooterOptionsService.isSavingInProgress();
    };
    PageHeaderFooterModalController.prototype.saveHeaderFooter = function () {
        var headerFooter = this.$scope.type;
        // @ts-ignore
        var options = this.$ctrl.headerFooterLayout[headerFooter];
        var headerFooterFormats = options.customTitle.formats;
        lodash_1.default.forEach(this.CONTENT_FORMAT_OPTIONS, function (option) {
            // @ts-ignore
            // @ts-ignore
            headerFooterFormats[option] = headerFooterFormats[option].selectedFormat
                // @ts-ignore
                || headerFooterFormats[option].selectedColor;
        });
        // TODO: Deprecate this quillObject - see page-header-footer-options-service.ts
        options.quillObject = this.pageHeaderFooterOptionsService.getContents(headerFooter);
        options.quillObjectHtml = $('#header-footer-text-editor .ql-editor').html();
        options.translationId = headerFooter;
        options.translatableAttributes = ['quillObjectHtml'];
        options.html = this.pageHeaderFooterGenerator.getHeaderFooterHTML(options);
        this.headerFooterService.updateHeaderOrFooter(headerFooter, this.$ctrl.headerFooterLayout);
    };
    PageHeaderFooterModalController.$inject = [
        '$scope',
        'prHeaderFooterService',
        'prPageHeaderFooterGenerator',
        'prPageHeaderFooterOptionsService'
    ];
    return PageHeaderFooterModalController;
}());
(function (angularModule) {
    angularModule.controller('prPageHeaderFooterModalController', PageHeaderFooterModalController);
})(angular.module('qualtrics.pr'));
